import React from 'react'
import { AspectRatio } from '@radix-ui/react-aspect-ratio'
import { Link } from 'gatsby'
import { PressLessImage } from '../primitives/image/gatsby-image-svg-fallback'
import StyledButton from '../primitives/styled-button'
import { LazyComponent } from '../../utils/use-in-view-port'

interface NormalImageCardProps {
    title?: string
    bodyText?: PressLessRichText | string
    buttonText?: string
    buttonLink?: string
    backgroundImage?: any
}

const NormalImageCard = ({
    title,
    bodyText,
    buttonText,
    buttonLink,
    backgroundImage,
}: NormalImageCardProps) => (
    <div
        role="group"
        css={{
            height: '100%',
            borderRadius: '16px',
            width: 'auto',
            display: 'flex',
            position: 'relative',
            alignItems: 'flex-start',
            flexDirection: 'column',
            transform: 'translateZ(0px)',
        }}
    >
        <div
            css={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'flex-start',
                flexDirection: 'column',
                borderRadius: '16px',
                overflow: 'hidden',
            }}
        >
            <Link
                to={buttonLink || ''}
                css={{
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                    left: 0,
                    top: 0,
                    borderRadius: '16px',
                    zIndex: 1,
                }}
            />
            <div
                css={{
                    width: '100%',
                    borderRadius: '16px',
                }}
            >
                <AspectRatio ratio={412 / 161}>
                    <div
                        css={{
                            width: '100%',
                            height: '100%',
                            overflow: 'hidden',
                            transform: 'translateZ(0px)',
                            borderRadius: '16px',
                            backgroundColor: 'var(--color-gray-mittelgrau)',
                        }}
                    >
                        {backgroundImage && (
                            <LazyComponent
                                style={{ width: '100%', height: '100%' }}
                                fallback={
                                    <div
                                        css={{ width: '100%', height: '100%' }}
                                    />
                                }
                            >
                                <PressLessImage
                                    image={backgroundImage}
                                    css={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        transition: '0.3s',
                                        borderRadius: '16px',
                                        transform: 'translateZ(0px)',
                                        position: 'relative',
                                        '[role="group"]:hover &': {
                                            transform: 'scale(1.04)',
                                        },
                                        '&:after': {
                                            content: '""',
                                            display: 'block',
                                            position: 'absolute',
                                            top: 0,
                                            left: 0,
                                            width: '100%',
                                            height: '100%',
                                            background: 'rgba(0, 45, 85, 0.1)',
                                        },
                                    }}
                                />
                            </LazyComponent>
                        )}
                    </div>
                </AspectRatio>
            </div>
            <div
                css={{
                    width: 'auto',
                    height: '100%',
                    maxWidth: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    backgroundColor: 'var(--color-gray-white)',
                    borderRadius: '16px',
                    paddingTop: '27px',
                    '@media (max-width: 767px)': {
                        paddingTop: '32px',
                    },
                }}
            >
                <div css={{ width: '100%' }}>
                    <div
                        className="h3"
                        css={{
                            paddingBottom: '24px',
                            '@media (max-width: 767px)': {
                                paddingBottom: '8px',
                            },
                        }}
                    >
                        {title}
                    </div>
                    <div
                        className="p1 ql-editor"
                        css={{
                            paddingBottom: '32px',
                        }}
                    >
                        {bodyText}
                    </div>
                </div>
                <div css={{ display: 'flex' }}>
                    <StyledButton
                        to={buttonLink || ''}
                        arrowRight
                        theme="secondary"
                    >
                        {buttonText || 'Mehr'}
                    </StyledButton>
                </div>
            </div>
        </div>
    </div>
)

export default NormalImageCard
